export default class FieldAllowedValueClasses {
  public static readonly MULTIPLE_FILES: string = 'multiple_files';
  public static readonly PHOTO: string = 'photo';
  public static readonly FILE: string = 'file';
  public static readonly LINKED_COMMUNITY_IDS_SELECT: string = 'linked_community_ids_select';
  public static readonly LINKED_PROJECT_IDS_SELECT: string = 'linked_project_ids_select';
  public static readonly SPECIALTIES_SELECT: string = 'specialties_select';
  public static readonly MAP_SPECIALTIES_SELECT: string = 'map_specialties_select';
  public static readonly MAP_CHARITY_FOCUSES_SELECT: string = 'map_charity_focuses_select';
  public static readonly LANGUAGES_SELECT: string = 'language_select';
  public static readonly LINKED_ORGANIZATION_IDS_SELECT: string = 'linked_organization_ids_select';
  public static readonly INSURANCE_CARRIER_CHECKBOX: string = 'insurance_carrier_checkbox';
  public static readonly DISEASES_SELECT: string = 'diseases_select';
  public static readonly CHARITY_FOCUSES: string = 'charity_focuses';
  public static readonly MAP_DISEASES_SELECT: string = 'map_diseases_select';
  public static readonly CHARACTERS: string = 'characters';
  public static readonly RICH_EDITOR: string = 'rich_editor';
  public static readonly COMMUNITIES_SEARCH_SELECT: string = 'communities_search_select';
  public static readonly CONNECT_COMMUNITY_SEARCH_SELECT: string = 'connect_community_search_select';
  public static readonly PROJECTS_SEARCH_SELECT: string = 'projects_search_select';
  public static readonly ALTERNATIVE_NAME: string = 'alternative_names';
  public static readonly TEXTAREA_FULL: string = 'textarea_full';
  public static readonly TEXTAREA: string = 'textarea';
  public static readonly DATE: string = 'date';
  public static readonly LOCATION: string = 'location';
  public static readonly LOCATION_ALL_TYPES: string = 'all_location';
  public static readonly CITY_LEVEL_LOCATION: string = 'city_level_location';
  public static readonly FULL_ADDRESS_LOCATION: string = 'full_address_location';
  public static readonly TEXT_LOCATION: string = 'text_location';
  public static readonly VIEWPORT: string = 'viewport';
  public static readonly ROLES_SELECT: string = 'roles_select';
  public static readonly MAP_ROLES_SELECT: string = 'map_roles_select';
  public static readonly EMAIL: string = 'email';
  public static readonly VERIFIED_EMAIL: string = 'verified_email';
  public static readonly WARNING_LABLE: string = 'warning_label';
  public static readonly ALIAS: string = 'alias';
  public static readonly ORGANIZATION_NAME: string = 'organization_name';
  public static readonly PHONE: string = 'phone';
  public static readonly PHONE_2FA: string = 'phone_2fa';
  public static readonly AUTHENTICATOR_BINDING: string = 'authenticator_binding';
  public static readonly ALPHABETIC: string = 'alphabetic';
  public static readonly ZIP_CODE: string = 'zip_code';
  public static readonly ALPHABETIC_NAME: string = 'alphabetic_name';
  public static readonly YES_NO_SELECT: string = 'yes_no_select';
  public static readonly GENDER_SELECT: string = 'gender_select';
  public static readonly SUFFIX_SELECT: string = 'suffix_select';
  public static readonly SEARCH_SELECT: string = 'search_select';
  public static readonly ORGANIZATIONS_TYPE_INPUT_SELECT: string = 'organization_type_input_select';
  public static readonly ALPHANUMERIC: string = 'alphanumeric';
  public static readonly URL: string = 'url';
  public static readonly TERMS_CHECKBOX: string = 'terms_checkbox';
  public static readonly SWITCH: string = 'switch';
  public static readonly FOCUS: string = 'focus';
  public static readonly CHECKBOX: string = 'checkbox';
  public static readonly IS_OPEN_SELECT: string = 'is_open_select';
  public static readonly VERIFICATION_CODE: string = 'verification_code';
}
